import moment from "moment";

const DateService = {
  getDurationMinutes: (value: number = 0) => {
    return value > 0
      ? moment.duration(value, "minutes").humanize()
      : "0 seconds";
  },

  getDurationString: (seconds: number = 0) => {
    let hours = seconds / 3600;
    let mins = (seconds % 3600) / 60;
    let secs = (mins * 60) % 60;

    hours = Math.trunc(hours);
    mins = Math.trunc(mins);

    if (!hours && !mins && !secs) return "0 sec";

    if (hours) {
      if (mins)
        return secs
          ? `${hours} hr ${mins} min & ${secs} sec`
          : `${hours} hr & ${mins} min`;
      else return secs ? `${hours} hr & ${secs} sec` : `${hours} hr`;
    } else {
      if (mins) return secs ? `${mins} min & ${secs} sec` : `${mins} min`;
      else return secs ? `${secs} sec` : `None`;
    }
  },

  getMonthString: (value: string = "") => {
    return moment(new Date(value)).format("MMMM-YYYY");
  },

  getDateRange: (value: any) => {
    return [
      value[0] ? new Date(value[0]).toString() : "",
      value[1] ? new Date(value[1]).toString() : "",
    ];
  },

  getShortDateString: (value: any) => {
    return value ? moment(value.replace("Z", "")).format("ddd, MMM DD") : "";
  },

  getSaudiaDateString(date: string | Date, format = "DD.MM.YYYY") {
    return moment(date).tz("Asia/Riyadh").format(format);
  },

  getShortSaudiaDateString(date: string | Date, format = "DD.MM.YYYY") {
    return moment(date).tz("Asia/Riyadh").format(format);
  },

  getSaudiaTimeString(date: string | Date, format = "hh:mm A") {
    return moment(date).tz("Asia/Riyadh").format(format);
  },

  getSaudiaDateAndTimeString: (value: any) => {
    return value
      ? moment(value).tz("Asia/Riyadh").format("ddd, MMM DD, YYYY hh:mm a")
      : "--";
  },

  getSaudiaDateAndTimeStringForExcel: (value: any) => {
    let date = moment(value).tz("Asia/Riyadh").format("YYYY-MM-DD hh:mm:ss");
    return date ? new Date(date) : "";
  },
  getDateString: (value: any, format = "ddd, MMM DD, YYYY") => {
    return value ? moment(value.replace("Z", "")).format(format) : "";
  },

  getTimeString: (value: any) => {
    return value ? moment(value.replace("Z", "")).format("hh:mm a") : "";
  },

  getDateTimeString: (value: any) => {
    return value
      ? moment(value.replace("Z", "")).format("ddd, MMM DD, YYYY, hh:mm a")
      : "";
  },
  getRiyadhDateTimeString: (value: any) => {
    return value
      ? moment(value).tz("Asia/Riyadh").format("ddd, MMM DD, YYYY, hh:mm a")
      : "";
  },

  getFormattedDate: (value: any) => {
    return value
      ? new Date(value).toLocaleDateString(undefined, {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : "";
  },
  getNumericDate: (value: any) => {
    return value
      ? new Date(value).toLocaleDateString("fr-CH", {
          // weekday: "numeric",
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";
  },

  getFormattedDateTime: (value: any) => {
    return value
      ? new Date(value).toLocaleDateString(undefined, {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: false,
        })
      : "";
  },
  getFormattedDateTimeForExcel: (value: any) => {
    if (!value) return null;
    const clean = value.replace("Z", "");
    const [datePart, timePart] = clean.split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hours, minutes, seconds);
    // const date = new Date(value);
    // return new Date(
    //   Date.UTC(
    //     date.getUTCFullYear(),
    //     date.getUTCMonth(),
    //     date.getUTCDate(),
    //     date.getUTCHours(),
    //     date.getUTCMinutes(),
    //     date.getUTCSeconds()
    //   )
    // );
  },

  getFormattedTime: (value: any) => {
    return value
      ? new Date(value).toLocaleDateString(undefined, {
          hour: "numeric",
          minute: "numeric",
          hour12: false,
        })
      : "";
  },

  getTimeOnly: (value: any) => {
    let valArr = value?.split(":");

    return value ? valArr[0] + ":" + valArr[1] : "";
  },
  getMomentDateFormat: (value: any) => {
    return value ? moment(value.replace("Z", "")).format("DD.MM.YYYY") : "--";
  },
  getMomentTimeFormat: (value: any) => {
    return value ? moment(value.replace("Z", "")).format("hh:mm a") : "--";
  },
  getMomentDateFormatZ: (value: any) => {
    return value ? moment.parseZone(value).format("DD.MM.YYYY") : "--";
  },
  getMomentTimeFormatZ: (value: any) => {
    return value ? moment.parseZone(value).format("hh:mm a") : "--";
  },
  getMomentDateFormatTZ: (value: any) => {
    return value ? moment(value).format("DD.MM.YYYY") : "--";
  },
  getMomentTimeFormatTZ: (value: any) => {
    return value ? moment(value).format("hh:mm a") : "--";
  },
  getMomentDateAndTimeFormatTZ: (value: any) => {
    return value ? moment(value).format("ddd, MMM DD, YYYY hh:mm a") : "--";
  },
  getMomentFullFormat: (value: any) => {
    return value
      ? moment(value.replace("Z", "")).format("DD.MM.YYYY hh:mm a")
      : "--";
  },
  getSmartDateString: (date: any, type?: any) => {
    if (type === "year") return date ? moment(date).format("Do,MMM YY") : "";
    return date ? moment(date).format("ddd, MMM DD") : "";
  },
  getSmartTimeString: (date: any) => {
    let value = date?.split("T")[1]?.split(":");
    return value ? `${value[0]}:${value[1]}` : "";
  },
  getTimeToDate: (value: any) => {
    const [hours, minutes] = value.split(":");
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toISOString();
  },
  getServerDateString: (value: any, sort?: boolean) => {
    let date = new Date(Date.parse(value));
    let formate = sort ? "ddd, MMM DD" : "ddd, MMM DD, YYYY";
    return date ? moment(date).format(formate) : "";
  },
  getServerTimeString: (value: any) => {
    let date = new Date(Date.parse(value));
    return date ? moment(date).format("hh:mm A") : "";
  },
  getTime: (value: any) => {
    return value ? moment(value).format("HH:mm:ss") : "";
  },
  getBrowserLocalDateTime: (value: any) => {
    if (!value) return "--";
    return moment(value).local().format("ddd, MMM DD, YYYY hh:mm A");
  },
};

export default DateService;
